import {
  getProductSpecGroups,
  MAX_BIGINT,
} from '@services/queries/products/getProductSpecGroups';
import { defQuery } from '@utils/defQuery';

export type ProductSpecsKey = [
  name1: 'products',
  name2: 'spec groups',
  productId?: undefined | null | string,
  searchTerm?: undefined | string,
  updatedAt?: undefined | null | string,
];
const SECOND = 1000;
const MINUTE = 60 * SECOND;
/**
 * Product specs query.
 *
 * Example way of writing queries, with Key exported from *.query.tsx files, and config created by defQuery().
 * Nb: Pass all args you'd pass to query fn through qKey if possible.
 */
export const productSpecsQuery = defQuery({
  queryKey: ['products', 'spec groups'] as ProductSpecsKey,
  queryFn: ({ queryKey }) => {
    const [, , productId, searchTerm] = queryKey;

    if (!productId) return null;
    return getProductSpecGroups({
      params: {
        limit: MAX_BIGINT.toString(),
        page: 1,
        q: searchTerm,
      },
      productId,
    });
  },
  staleTime: 1 * MINUTE,
});
